<template>
    <div class="lang-list">
        <a class="u-reset lang-list--link"
                v-for="(lang, idx) in languages"
                :key="idx"
                :href="lang.path">
            {{ lang.label }}
        </a>
    </div>
</template>

<script>
    export default {
        props: {
            /** @type {ILink[]} */
            languages: {
                type: Array,
                default: () => [],
            },
        },
    };
</script>
